import Image from "next/image";
import BasicBlock from "../shared/basic-block";
import { CDN_URL } from "@/consts";

const EditorDemoSection = () => {
  return (
    <BasicBlock
      header="Full control with our web editor."
      mobileHeader="Web-Based Editor."
      headerStyle="leading-none gap-0"
      subHeader="Feels like magic."
      subHeaderStyle="text-[38px] font-semibold md:text-[48px] leading-none text-black"
      // bgStyle="bg-gradient-to-b from-white to-[#97BAFF]/20"
    >
      <div className="w-full rounded-2xl bg-[#0052B4]/10 p-1 md:p-2">
        <Image
          src={`${CDN_URL}/landing/editor.png`}
          alt="Editor Demo"
          width={2368}
          height={1281}
          draggable={false}
          className="w-full rounded-2xl border border-[#6D9EFF]"
        />
      </div>
    </BasicBlock>
  );
};

export default EditorDemoSection;
